
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/video",
      function () {
        return require("private-next-pages/news/video.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/video"])
      });
    }
  